// Mirrors dcp_ai_fitness: lib/models/explore_item.dart (ExploreCategory,
// ExploreDisplayType) and lib/screens/admin/* (labels, hints, muscle keys).

// Icerigi hangi dilde GORUNTULEYECEGIMIZ. Turkce ilk ve varsayilan: kanonik
// kaynak o, digerleri ceviri. Turkce disi bir dil secildiginde panel salt
// okunur hale gecer — form hangi dili yuklediyse onu geri yaziyor, yani
// Almanca gorunumde kaydetmek kanonik Turkce'yi ezer.
export const VIEW_LANGS = [
  { key: 'tr', label: 'TR' },
  { key: 'en', label: 'EN' },
  { key: 'de', label: 'DE' },
  { key: 'es', label: 'ES' },
  { key: 'fr', label: 'FR' },
  { key: 'it', label: 'IT' },
];

export const SOURCE_LANG = 'tr';

export const CATEGORIES = [
  {
    key: 'recipes',
    label: 'Tarif',
    description: 'Fitness tarifleri: kalori, malzeme, makro bilgileri içerir.',
  },
  {
    key: 'quick_tips',
    label: 'Beslenme',
    description: 'Kısa bilgi kartları: ikon, renk ve detay içerik barındırır.',
  },
  {
    key: 'exercise_videos',
    label: 'Hareketler',
    description: 'Egzersiz tanımları: video, hedef kas grupları ve talimatlar içerir.',
  },
  {
    key: 'mini_guides',
    label: 'Mini Rehber',
    description: 'Mini rehberler: markdown içerik, okuma süresi ve etiketler barındırır.',
  },
  {
    key: 'training',
    label: 'Antrenman',
    description: 'Antrenman içerikleri: markdown içerik, okuma süresi ve etiketler barındırır.',
  },
  {
    key: 'supplement',
    label: 'Supplement',
    description: 'Supplement içerikleri: markdown içerik, okuma süresi ve etiketler barındırır.',
  },
];

export const categoryLabel = (key) =>
  CATEGORIES.find((c) => c.key === key)?.label ?? key;

// Categories whose form shows the shared markdown/content fields.
export const CONTENT_CATEGORIES = ['quick_tips', 'training', 'mini_guides', 'supplement'];

export const DISPLAY_TYPES = [
  { key: 'image', label: 'Görsel', hint: 'Standart görsel kartı' },
  { key: 'video', label: 'Video', hint: 'Video oynatıcı kartı' },
  { key: 'gallery', label: 'Galeri', hint: 'Çoklu görsel kaydırmalı' },
  { key: 'info_tile', label: 'Bilgi', hint: 'İkon + renk arka plan kartı' },
];

export const displayTypeLabel = (key) =>
  DISPLAY_TYPES.find((d) => d.key === key)?.label ?? key;

export const DIFFICULTIES = [
  { key: 'easy', label: 'Kolay', color: '#4CAF50' },
  { key: 'medium', label: 'Orta', color: '#FFA726' },
  { key: 'hard', label: 'Zor', color: '#EF5350' },
];

// Keys match ExploreItem.targetMuscles / the anatomy filter.
export const MUSCLES = [
  { key: 'chest', label: 'Göğüs' },
  { key: 'back', label: 'Sırt' },
  { key: 'lower_back', label: 'Bel' },
  { key: 'shoulders', label: 'Omuz' },
  { key: 'biceps', label: 'Biceps' },
  { key: 'triceps', label: 'Triceps' },
  { key: 'forearms', label: 'Ön Kol' },
  { key: 'abs', label: 'Karın' },
  { key: 'quadriceps', label: 'Ön Bacak' },
  { key: 'hamstrings', label: 'Arka Bacak' },
  { key: 'glutes', label: 'Kalça' },
  { key: 'calves', label: 'Baldır' },
  { key: 'traps', label: 'Trapez' },
];

export const MUSCLE_KEYS = MUSCLES.map((m) => m.key);
